<template>
  <div class="vl-parent">
    <!-- <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    /> -->

    <div id="overlay" v-if="isLoading"></div>

    <router-view></router-view>
  </div>
</template>

<script>
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  data() {
    return {
      fullPage: true,
    };
  },
  components: {
    // Loading,
  },
  computed: {
    isLoading() {
      return this.$store.state.all.isLoading;
    }
  },
};
</script>

<style scoped>
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: block; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2000; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
  background-image : url("./assets/images/loading-ems.gif");
  background-size: 33%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center; 
  backdrop-filter: blur(10px); /* Add blur effect to background */
  -webkit-backdrop-filter: blur(10px); /* Safari support */
}
</style>